import _ from 'lodash'
import Backbone from 'backbone'
import MultiChoiceFilter from 'scoreboard/reports/common/filter/multichoice-filter'
import AppliesToDateFilter from 'scoreboard/reports/common/filter/applies-to-date-filter'
import template from './initiative-calculations-filter.hbs'
import multichoiceCheckboxTemplate from 'scoreboard/reports/common/filter/multichoice-checkbox-filter.hbs'

const MutilchoiceInitiativeCalculationsFilter = Backbone.View.extend({

	className: 'report-filters filter numeric-applies-to-date-filter',

	/**
	 * @constructs A view that combines a number and date filter together to
	 * provide a scorecards filter where you can specify a number in a given date range
	 *
	 * @param options
	 */
	initialize: function(options = {}) {
		this.options = options
		this.data = options.data
		let multiChoiceOptions = _.extend({
			template: multichoiceCheckboxTemplate,
			customTemplate: true
		}, options)
		this.multiChoiceFilter = new MultiChoiceFilter(multiChoiceOptions)
		// #37881 provide a reference to the custom form test for
		// multiChoiceFilter for this view's test function
		this.multiChoiceFilter.formTest = new this.multiChoiceFilter.formViewType().test
		this.appliesToDateFilter = new AppliesToDateFilter(_.cloneDeep(options))
	},

	render: function() {
		this.$el.html(template())
		this.multiChoiceFilter.setElement(this.$('.filter-on-container')).render()
		this.appliesToDateFilter.setElement(this.$('.applies-to-container')).render()
		return this
	},

	/**
	 * Provides validation to this view
	 */
	test: function() {
		// #37881 also validate that a color selection has been made
		let problem = this.multiChoiceFilter.formTest()
		if (problem) {
			return problem
		}
		return this.appliesToDateFilter.test()
	},

	/**
	 * Returns the data gather by the filters used in this view
	 */
	gather: function(e) {
		return _.extend(this.data, this.multiChoiceFilter.gather(), this.appliesToDateFilter.gather())
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.multiChoiceFilter, this.appliesToDateFilter], 'remove')
	}

})

export default MutilchoiceInitiativeCalculationsFilter

MutilchoiceInitiativeCalculationsFilter.__filename__ = 'reports/wizard/initiative-report/multichoice-initiative-calculations-filter.js'
